import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LoginPage.module.css';

const LoginPage = ({ onLoginSuccess }) => {
  // 1. 초기 상태값을 username으로 정확히 설정
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    // name이 "username"이면 credentials.username이 업데이트됩니다.
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const loginParams = new URLSearchParams();
      loginParams.append('username', credentials.username);
      loginParams.append('password', credentials.password);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: loginParams,
        credentials: 'include',
      });


      if (response.ok) {
        // 1. JSON Body에서 데이터 읽기
        const data = await response.json();

        // 2. AccessToken 추출 및 Bearer 접두사 제거
        if (data.success && data.AccessToken) {
          const token = data.AccessToken.startsWith('Bearer ')
            ? data.AccessToken.substring(7)
            : data.AccessToken;

          // 3. 로컬 스토리지에 저장 (ProtectedRoute가 검사하는 키값)
          localStorage.setItem('AccessToken', token);

          const companyName = data.companyName;
          localStorage.setItem('companyName', companyName);

          if (onLoginSuccess) onLoginSuccess();

          // 4. 홈으로 이동
          navigate('/admin', { replace: true });
        } else {
          setError('인증 정보가 올바르지 않습니다.');
        }
      } else {
        setError('아이디 또는 비밀번호가 올바르지 않습니다.');
      }
    } catch (err) {
      console.error('Login Error:', err);
      setError('서버와 통신 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <h1 className={styles.logo}>MUBIZ <span>ADMIN</span></h1>
          <p className={styles.subtitle}>무비즈 관리자 시스템입니다.</p>
        </div>

        <form onSubmit={handleLogin} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="username">아이디</label>
            <input
              type="text"
              id="username"
              name="username"
              /* 2. value를 credentials.username으로 수정 (핵심!) */
              value={credentials.username}
              onChange={handleChange}
              placeholder="아이디를 입력하세요"
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="비밀번호를 입력하세요"
              required
            />
          </div>

          {error && <p className={styles.errorMessage}>{error}</p>}

          <button type="submit" className={styles.loginBtn} disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className={styles.footer}>
          <p>계정 정보 분실 시 본사에 문의하세요.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;